import { Injector, Type } from '@angular/core';

import { mergeAttributes, Node as TipTapNode } from '@tiptap/core';
import { AngularNodeViewComponent, AngularNodeViewRenderer } from 'ngx-tiptap';

import { APP_TIPTAP_EDITOR_RENDER_AS } from '../tokens';

export type EmailRegistrantsOptions = {
    HTMLAttributes: Record<string, any>;
};
declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        emailRegistrants: {
            insertEmailRegistrants: () => ReturnType;

            updateEmailRegistrants: () => ReturnType;
        };
    }
}

export const createEmailRegistrantsExtension = (injector: Injector, component: Type<AngularNodeViewComponent>) => {
    const renderAs = injector.get(APP_TIPTAP_EDITOR_RENDER_AS);

    return TipTapNode.create<EmailRegistrantsOptions>({
        name: 'emailRegistrants',
        inline: false,
        group: 'block',
        selectable: true,
        draggable: true,
        atom: true,

        addOptions() {
            return {
                HTMLAttributes: {},
            };
        },

        addAttributes() {
            return {
                variable: {
                    default: '',
                },
                options: undefined,
            };
        },

        parseHTML() {
            return [{ tag: `[data-type="${this.name}"]` }];
        },

        renderHTML({ node, HTMLAttributes }) {
            if (renderAs === 'html') {
                return [
                    'div',
                    mergeAttributes(this.options.HTMLAttributes, {
                        // ...HTMLAttributes,
                        options: HTMLAttributes['options'] || undefined,

                        style: HTMLAttributes['style'],
                        'data-type': this.name,
                    }),
                ];
            }

            return [
                'div',
                mergeAttributes(this.options.HTMLAttributes, {
                    style: HTMLAttributes['style'],
                }),
                '{% for reg in zoomRegistrants %}',
                [
                    'p',
                    {},
                    'You are registered for the {{ reg.Topic }}.',
                    '{% if reg.StartDate %}',
                    ' It starts {{ reg.StartDate | time_zone: "Mountain Standard Time" | format_date:"MMMM dd, yyyy h:mm tt", "en-us" }}',
                    '{% endif %}',
                ],

                ['p', {}, ['a', { href: '{{ reg.JoinUrl }}' }, 'Click Here to Join {{ reg.Topic }}']],
                '{% endfor %}',
            ];
        },

        addNodeView() {
            return AngularNodeViewRenderer(component, { injector });
        },

        addCommands() {
            return {
                insertEmailRegistrants:
                    () =>
                    ({ tr, dispatch, editor }) => {
                        const { selection } = tr;
                        const node = this.type.create();

                        if (dispatch) {
                            tr.replaceRangeWith(selection.from, selection.to, node);
                        }

                        return true;
                    },

                updateEmailRegistrants:
                    () =>
                    ({ chain, tr }) => {
                        const config: Record<string, string> = {};
                        const node = (tr as any).curSelection?.node;

                        if (!node || node.type.name !== this.name) {
                            return false;
                        }

                        return chain().updateAttributes(this.name, config).run();
                    },
            };
        },
    });
};
